//TODO document this
//TODO clean up public map dynamic filters, toggles, and controls

export const BASEMAP_STYLES = [
  {
    style: "standard-satellite",
    name: "Standard Satellite",
    url: "mapbox://styles/mapbox/standard-satellite",
  },
  {
    style: "standard",
    name: "Standard",
    url: "mapbox://styles/mapbox/standard",
  },
  {
    style: "streets-v12",
    name: "Streets",
    url: "mapbox://styles/mapbox/streets-v12",
  },
  {
    style: "outdoors-v12",
    name: "Outdoors",
    url: "mapbox://styles/mapbox/outdoors-v12",
  },
  {
    style: "light-v11",
    name: "Light",
    url: "mapbox://styles/mapbox/light-v11",
  },
  {
    style: "dark-v11",
    name: "Dark",
    url: "mapbox://styles/mapbox/dark-v11",
  },
  {
    style: "satellite-v9",
    name: "Satellite",
    url: "mapbox://styles/mapbox/satellite-v9",
  },
  {
    style: "satellite-streets-v12",
    name: "Satellite Streets",
    url: "mapbox://styles/mapbox/satellite-streets-v12",
  },
  {
    style: "navigation-day-v1",
    name: "Navigation Day",
    url: "mapbox://styles/mapbox/navigation-day-v1",
  },
  {
    style: "navigation-night-v1",
    name: "Navigation Night",
    url: "mapbox://styles/mapbox/navigation-night-v1",
  },
];

export const DEFAULT_MAP_CENTER = [-98.07593, 30.13326];
export const BASEMMAP_IMAGE_CENTER = DEFAULT_MAP_CENTER;
export const DEFAULT_MAP_ZOOM = 10;
export const DEFAULT_MAP_BASEMAP = BASEMAP_STYLES[0].url;
export const CIRCLE_FALLBACK_COLOR = "#9e9e9e";

export const INIT_MAP_CONFIG = {
  style: DEFAULT_MAP_BASEMAP,
  center: DEFAULT_MAP_CENTER,
  zoom: DEFAULT_MAP_ZOOM,
  preserveDrawingBuffer: true,
  attributionControl: true,
};

export const WELLS_CIRCLE_LAYER_ID = "map-locations-circle";
export const WELLS_LABELS_LAYER_ID = "map-locations-symbol-label";

// a dynamic color-by must be included in this list as well. if it should be colored but not filtered, just add the excludeFilter boolean
export const INIT_FILTER_VALUES = {
  wellPurpose: {
    label: "Well Purpose",
    name: "wellPurpose",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "well_purpose_desc",
    options: [],
    type: "multi-select",
    value: [],
  },
  wellStatus: {
    label: "Well Status",
    name: "wellStatus",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "well_status_desc",
    options: [],
    type: "multi-select",
    value: [],
  },
  aquifer: {
    label: "Aquifer",
    name: "aquifer",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "aquifer_desc",
    options: [],
    type: "multi-select",
    value: [],
  },
  aquiferStrata: {
    label: "Aquifer Strata",
    name: "aquiferStrata",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "aquifer_strata_desc",
    options: [],
    type: "multi-select",
    value: [],
  },
  mapGwdbLegend: {},
};

export const INIT_STYLE_VALUES = {
  default: {
    id: "default",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "",
    name: "Default",
    paint: {
      "circle-color": "#007cbf",
      "circle-stroke-color": "#fff",
      "circle-radius": [
        "interpolate",
        ["exponential", 1.5],
        ["zoom"],
        5,
        4,
        10,
        7,
        15,
        10,
      ],
      "circle-stroke-width": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        5,
        1,
        10,
        1.5,
        15,
        2,
      ],
    },
  },
  wellPurpose: {
    id: "wellPurpose",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "well_purpose_desc",
    name: "Well Purpose",
    paint: {},
  },
  wellStatus: {
    id: "wellStatus",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "well_status_desc",
    name: "Well Status",
    paint: {},
  },
  aquifer: {
    id: "aquifer",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "aquifer_desc",
    name: "Aquifer",
    paint: {},
  },
  aquiferStrata: {
    id: "aquiferStrata",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "aquifer_strata_desc",
    name: "Aquifer Strata",
    paint: {},
  },
  wellElevation: {
    id: "wellElevation",
    layerId: WELLS_CIRCLE_LAYER_ID,
    layerFieldName: "ft_elevation",
    name: "Well Elevation",
    paint: {
      "circle-color": [
        "interpolate-hcl",
        ["linear"],
        ["to-number", ["coalesce", ["get", "ft_elevation"], Infinity]],
        // the below is a fallback for null/undefined/falsy values, namely 0
        // [
        //   "to-number",
        //   [
        //     "case",
        //     [
        //       "any",
        //       [
        //         "!",
        //         ["to-boolean", ["coalesce", ["get", "ft_elevation"], null]],
        //       ], // Handles null/undefined/falsy
        //       ["==", ["to-number", ["get", "ft_elevation"]], 0], // Explicit 0 or 0.00000
        //     ],
        //     Infinity, // Fallback for null or 0
        //     ["to-number", ["get", "ft_elevation"]], // Use actual number otherwise
        //   ],
        // ],
        0,
        "#0d47a1", // Very Low (Dark Blue)
        550,
        "#1565c0", // Low (Medium Dark Blue)
        750,
        "#1e88e5", // Moderate Low (Bright Blue)
        950,
        "#42a5f5", // Moderate (Sky Blue)
        1050,
        "#90caf9", // Moderate High (Light Blue)
        1200,
        "#e3f2fd", // High (Pale Blue)
        Infinity,
        CIRCLE_FALLBACK_COLOR, // N/A or Null (Gray)
      ],
    },
  },
};

export const SEARCH_CONFIG = {
  "map-locations": {
    id: "map-locations",
    label: "Hays Trinity Wells",
    key: "ndx",
    searchableFields: [
      "ndx",
      "well_name",
      "id_district",
      "id_well_report_tracking_number",
      "well_status_desc",
      "well_purpose_desc",
      "aquifer_desc",
      "aquifer_strata_desc",
      "address",
      "city",
    ],
    searchPlaceholder: "Search Hays Trinity Wells",
    displayFields: [
      { field: "ndx", label: "Well #" },
      { field: "well_name", label: "Well Name" },
      { field: "id_district", label: "District #" },
      {
        field: "id_well_report_tracking_number",
        label: "Well Report Tracking Number SDR",
      },
      { field: "well_status_desc", label: "Status" },
      { field: "well_purpose_desc", label: "Purpose" },
      { field: "aquifer_desc", label: "Aquifer" },
      { field: "aquifer_strata_desc", label: "Aquifer Strata" },
      { field: "address", label: "Address" },
      { field: "city", label: "City" },
    ],
  },
};

// This is the order in which the layer accordions will be displayed in the legend, if not defined here, the remaining items will be order alphabetically
export const ACCORDION_GROUPS_ORDER = ["Well Layers"];

export const ICON_IMAGES = [
  {
    url: "/static/img/mapbox/triangle.png",
    id: "triangle",
  },
  {
    url: "/static/img/mapbox/square.png",
    id: "square",
  },
  {
    url: "/static/img/mapbox/circle.png",
    id: "circle",
  },
  {
    url: "/static/img/mapbox/star.png",
    id: "star",
  },
];
